/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRegisterDto } from './GetRegisterDto';
import {
    GetRegisterDtoFromJSON,
    GetRegisterDtoFromJSONTyped,
    GetRegisterDtoToJSON,
} from './GetRegisterDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetCardDto } from './GetCardDto';
import {
    GetCardDtoFromJSON,
    GetCardDtoFromJSONTyped,
    GetCardDtoToJSON,
} from './GetCardDto';
import type { GetArticleDto } from './GetArticleDto';
import {
    GetArticleDtoFromJSON,
    GetArticleDtoFromJSONTyped,
    GetArticleDtoToJSON,
} from './GetArticleDto';

/**
 * 
 * @export
 * @interface GetJudgmentWithSignedInfoDto
 */
export interface GetJudgmentWithSignedInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    lp?: number | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    nextExamDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    judgmentDate?: Date | null;
    /**
     * 
     * @type {GetArticleDto}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    article?: GetArticleDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    psychologist?: GetUserDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    occupationalMedicineOneCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    vehicleRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    personRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    roadTransport?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    withoutSign?: boolean | null;
    /**
     * 
     * @type {GetRegisterDto}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    register?: GetRegisterDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    twilightVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    glareSensitivity?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    comment?: string | null;
    /**
     * 
     * @type {GetCardDto}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    card?: GetCardDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    art39j?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    contactWithFood?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    dateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    dateTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    requiresCorrectiveEyewear?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    statusP1: GetJudgmentWithSignedInfoDtoStatusP1Enum | null;
    /**
     * Status of the judgment cancellation document in P1, if any
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    cancelStatusP1: GetJudgmentWithSignedInfoDtoCancelStatusP1Enum | null;
    /**
     * Reason given for the judgment cancellation in P1, if any
     * @type {string}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    cancellationReason: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentWithSignedInfoDto
     */
    signed?: boolean | null;
}


/**
 * @export
 */
export const GetJudgmentWithSignedInfoDtoStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentWithSignedInfoDtoStatusP1Enum = typeof GetJudgmentWithSignedInfoDtoStatusP1Enum[keyof typeof GetJudgmentWithSignedInfoDtoStatusP1Enum];

/**
 * @export
 */
export const GetJudgmentWithSignedInfoDtoCancelStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentWithSignedInfoDtoCancelStatusP1Enum = typeof GetJudgmentWithSignedInfoDtoCancelStatusP1Enum[keyof typeof GetJudgmentWithSignedInfoDtoCancelStatusP1Enum];


/**
 * Check if a given object implements the GetJudgmentWithSignedInfoDto interface.
 */
export function instanceOfGetJudgmentWithSignedInfoDto(value: object): value is GetJudgmentWithSignedInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('statusP1' in value) || value['statusP1'] === undefined) return false;
    if (!('cancelStatusP1' in value) || value['cancelStatusP1'] === undefined) return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    return true;
}

export function GetJudgmentWithSignedInfoDtoFromJSON(json: any): GetJudgmentWithSignedInfoDto {
    return GetJudgmentWithSignedInfoDtoFromJSONTyped(json, false);
}

export function GetJudgmentWithSignedInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJudgmentWithSignedInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'nextExamDate': json['nextExamDate'] == null ? undefined : (new Date(json['nextExamDate'])),
        'judgmentDate': json['judgmentDate'] == null ? undefined : (new Date(json['judgmentDate'])),
        'article': json['article'] == null ? undefined : GetArticleDtoFromJSON(json['article']),
        'psychologist': json['psychologist'] == null ? undefined : GetUserDtoFromJSON(json['psychologist']),
        'pass': json['pass'] == null ? undefined : json['pass'],
        'occupationalMedicineOneCategory': json['occupationalMedicineOneCategory'] == null ? undefined : json['occupationalMedicineOneCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'vehicleRestriction': json['vehicleRestriction'] == null ? undefined : json['vehicleRestriction'],
        'personRestriction': json['personRestriction'] == null ? undefined : json['personRestriction'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'roadTransport': json['roadTransport'] == null ? undefined : json['roadTransport'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
        'register': json['register'] == null ? undefined : GetRegisterDtoFromJSON(json['register']),
        'twilightVision': json['twilightVision'] == null ? undefined : json['twilightVision'],
        'glareSensitivity': json['glareSensitivity'] == null ? undefined : json['glareSensitivity'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'card': json['card'] == null ? undefined : GetCardDtoFromJSON(json['card']),
        'art39j': json['art39j'] == null ? undefined : json['art39j'],
        'contactWithFood': json['contactWithFood'] == null ? undefined : json['contactWithFood'],
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'requiresCorrectiveEyewear': json['requiresCorrectiveEyewear'] == null ? undefined : json['requiresCorrectiveEyewear'],
        'statusP1': json['statusP1'],
        'cancelStatusP1': json['cancelStatusP1'],
        'cancellationReason': json['cancellationReason'],
        'signed': json['signed'] == null ? undefined : json['signed'],
    };
}

export function GetJudgmentWithSignedInfoDtoToJSON(value?: GetJudgmentWithSignedInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'lp': value['lp'],
        'exam': GetExamDtoToJSON(value['exam']),
        'nextExamDate': value['nextExamDate'] == null ? undefined : ((value['nextExamDate'] as any).toISOString()),
        'judgmentDate': value['judgmentDate'] == null ? undefined : ((value['judgmentDate'] as any).toISOString()),
        'article': GetArticleDtoToJSON(value['article']),
        'psychologist': GetUserDtoToJSON(value['psychologist']),
        'pass': value['pass'],
        'occupationalMedicineOneCategory': value['occupationalMedicineOneCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'vehicleRestriction': value['vehicleRestriction'],
        'personRestriction': value['personRestriction'],
        'drivingLicense': value['drivingLicense'],
        'roadTransport': value['roadTransport'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
        'register': GetRegisterDtoToJSON(value['register']),
        'twilightVision': value['twilightVision'],
        'glareSensitivity': value['glareSensitivity'],
        'comment': value['comment'],
        'card': GetCardDtoToJSON(value['card']),
        'art39j': value['art39j'],
        'contactWithFood': value['contactWithFood'],
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom'] as any).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo'] as any).toISOString()),
        'requiresCorrectiveEyewear': value['requiresCorrectiveEyewear'],
        'statusP1': value['statusP1'],
        'cancelStatusP1': value['cancelStatusP1'],
        'cancellationReason': value['cancellationReason'],
        'signed': value['signed'],
    };
}

